import{a as t}from"./chunk-WIMGWYZL.js";function i(...e){return t(o,e)}function o(e,r){let a={};for(let[n,u]of Object.entries(e)){let l=r(u,n,e);a[n]=l}return a}export{i as a};
